import { basicUIPlugin } from '@stackflow/plugin-basic-ui'
import '@stackflow/plugin-basic-ui/index.css'
import { basicRendererPlugin } from '@stackflow/plugin-renderer-basic'
import { stackflow } from '@stackflow/react'
import { GetServerSideProps } from 'next'
import { useMemo } from 'react'
import MaterialsBookmarkActivity from '../../../../components/webview/materials/MaterialsBookmarkActivity'
import MaterialsCategoryActivity from '../../../../components/webview/materials/MaterialsCategoryActivity'
import MaterialsDetailActivity from '../../../../components/webview/materials/MaterialsDetailActivity'
import MaterialsListActivity from '../../../../components/webview/materials/MaterialsListActivity'
import MaterialsPrevActivity from '../../../../components/webview/materials/MaterialsPrevActivity'
import MaterialsSearchActivity from '../../../../components/webview/materials/MaterialsSearchActivity'

const activities = {
  MaterialsListActivity,
  MaterialsDetailActivity,
  MaterialsCategoryActivity,
  MaterialsPrevActivity,
  MaterialsBookmarkActivity,
  MaterialsSearchActivity,
}

export type MaterialsActivityNamesType = keyof typeof activities

export const useMaterialsStack = (initialActivityName?: string | string[], initialParams?) => {
  const {
    Stack: MaterialsStack,
    useFlow: useMaterialsFlow,
    activities: MaterialsActivities,
  } = useMemo(() => {
    return stackflow({
      transitionDuration: 350,
      activities: activities,
      plugins: [
        basicRendererPlugin(),
        basicUIPlugin({
          theme: 'cupertino',
        }),
        () => {
          return {
            key: 'query-param-nested-navigation-plugin',
            overrideInitialEvents: ({ initialEvents }) => {
              const temp = {
                ...initialEvents[0],
                activityName: initialActivityName as MaterialsActivityNamesType,
                activityParams: initialParams,
              }
              return [temp]
            },
          }
        },
      ],
      initialActivity: () => initialActivityName as MaterialsActivityNamesType,
    })
  }, [initialActivityName])

  return { MaterialsStack, useMaterialsFlow, MaterialsActivities }
}

const Index = ({ activity, materialId, categoryId }) => {
  const { MaterialsStack } = useMaterialsStack(activity, { materialId: materialId, categoryId: categoryId })

  return (
    <div className="h-full w-full ">
      <MaterialsStack />
    </div>
  )
}

export const getServerSideProps: GetServerSideProps = async (props) => {
  const { query } = props
  const { activity = 'MaterialsListActivity', materialId = '', categoryId = '' } = query
  return {
    props: {
      activity: activity,
      materialId: materialId,
      categoryId: categoryId,
    },
  }
}

export default Index
